import * as React from "react";
import type { SVGProps } from "react";
const SvgPercentageSticker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m20.36 9.03.7.7a3.202 3.202 0 0 1 .01 4.52l-.71.71c-.23.22-.35.52-.35.84v1c0 1.76-1.44 3.2-3.2 3.2h-1c-.31 0-.61.13-.84.35l-.7.7c-.6.6-1.41.94-2.26.94-.86 0-1.66-.33-2.26-.93l-.71-.71c-.22-.23-.52-.35-.84-.35h-1A3.21 3.21 0 0 1 4 16.8v-1c0-.31-.13-.62-.35-.84l-.7-.7a3.2 3.2 0 0 1-.01-4.52l.71-.71c.22-.22.35-.53.35-.84v-1c0-1.76 1.44-3.2 3.2-3.2h1c.31 0 .61-.13.84-.35l.7-.7c.6-.6 1.41-.94 2.26-.94.86 0 1.66.33 2.26.93l.71.71c.22.23.52.35.84.35h1c1.76 0 3.2 1.44 3.2 3.2v1c0 .31.13.61.35.84m-1.42 4.52.7-.7v-.01c.24-.24.36-.54.36-.86s-.12-.62-.35-.85l-.7-.7c-.6-.6-.93-1.4-.93-2.25v-1c0-.66-.54-1.2-1.2-1.2h-1c-.85 0-1.65-.33-2.25-.93l-.7-.7c-.23-.24-.53-.36-.85-.36s-.62.12-.85.35l-.7.7c-.61.6-1.41.93-2.26.93h-1c-.66 0-1.2.54-1.2 1.2v1c0 .85-.33 1.65-.93 2.25l-.7.7c-.24.24-.36.54-.36.86s.12.62.35.85l.7.7c.6.61.93 1.41.93 2.26v1c0 .66.54 1.2 1.2 1.2h1c.86 0 1.66.33 2.26.93l.7.7c.23.24.53.36.85.36s.62-.12.85-.35l.7-.7c.6-.6 1.4-.93 2.25-.93h1c.66 0 1.2-.54 1.2-1.2v-1c0-.85.33-1.65.93-2.25m-10.66.73 6-6h.01a.996.996 0 1 1 1.41 1.41l-6 6c-.2.19-.45.29-.71.29s-.51-.09-.71-.29a.996.996 0 0 1 0-1.41m2.71-4.79c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5m3.5 3.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPercentageSticker;
